import { DISABLED_GUARDIAN_AGENT_TYPES } from '@/config/guardians.js';

/**
 * Mixin for fetching and filtering guardians based on user's sector
 * Can be used in any component that displays guardians
 */
export const GuardianFilterMixin = {
    data() {
        return {
            availableAgentTypes: null,
        };
    },
    computed: {
        filteredGuardians() {
            // Handle undefined/null guardians array
            if (!this.guardians || !Array.isArray(this.guardians)) {
                return [];
            }

            // While loading or if no available types, show only PATTY
            if (
                !this.availableAgentTypes ||
                !Array.isArray(this.availableAgentTypes)
            ) {
                return this.guardians.filter(
                    (g) => g && g.agentType === 'PATTY'
                );
            }

            // Filter guardians by available agent types and disabled list
            return this.guardians.filter(
                (g) =>
                    g &&
                    g.agentType &&
                    !DISABLED_GUARDIAN_AGENT_TYPES.includes(g.agentType) &&
                    this.availableAgentTypes.includes(g.agentType)
            );
        },
    },
    methods: {
        async fetchAvailableAgents() {
            try {
                const response = await this.$getData(
                    'openai/assistant-thread/agents/available'
                );

                // Validate response structure
                if (
                    response?.success &&
                    response.data?.agents &&
                    Array.isArray(response.data.agents)
                ) {
                    this.availableAgentTypes = response.data.agents
                        .map((a) => a?.agentType)
                        .filter((type) => type); // Remove any undefined/null values
                } else {
                    // Fallback to just PATTY
                    this.availableAgentTypes = ['PATTY'];
                }
            } catch (error) {
                console.error('Failed to fetch available agents:', error);
                // Fallback to just PATTY on error
                this.availableAgentTypes = ['PATTY'];
            }
        },
    },
};
